import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @file Trigger.ts
 * @author markJia(markjia@tencent.com)
 * @desc append and upload trigger
 */
import { useRefCallback } from '@tencent/glue-react-use';
import React, { useCallback, useRef, useState } from 'react';
import { ViewDropTrigger } from '../DropTrigger';
/**
 * 上传文件匹配
 *
 * @param file File
 * @param accept 文件类型标识符
 * @return {boolean} 是否符合
 */

export var isAccept = function isAccept(file, accept) {
  if (!file || !accept) {
    return true;
  }

  var acceptArray = Array.isArray(accept) ? accept : accept.split(',');
  var _file$name = file.name,
      name = _file$name === void 0 ? '' : _file$name,
      _file$type = file.type,
      type = _file$type === void 0 ? '' : _file$type;
  var fileName = name.toLowerCase().trim();
  var fileType = type.toLowerCase().trim();
  var baseFileType = fileType.replace(/\/.*$/, '');

  var _iterator = _createForOfIteratorHelper(acceptArray),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var acceptStr = _step.value;

      var _accept = acceptStr.toLowerCase().trim(); // 完全匹配


      if (_accept === fileType || _accept === '*') {
        return true;
      } // 后缀匹配


      if (_accept.charAt(0) === '.' && fileName.endsWith(_accept)) {
        return true;
      } // 部分匹配，类似 application/*


      var acceptBaseType = _accept.replace(/\/.*$/, '');

      if (/\/\*$/.test(_accept) && acceptBaseType === baseFileType) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};
/**
 * 符合accept的文件
 *
 * @param fileList FileList选取的
 * @return {Array<File>} 符合accept的文件列表
 */

export var filesAcceptFilter = function filesAcceptFilter(fileList, accept) {
  var result = [];

  for (var _i = 0, _Array$from = Array.from(fileList); _i < _Array$from.length; _i++) {
    var file = _Array$from[_i];
    isAccept(file, accept) && result.push(file);
  }

  return result;
};
export var DEFAULT_TRIGGER_STYLE = {
  flex: 'auto'
};
export var FileTrigger = function FileTrigger(props) {
  var className = props.className,
      children = props.children,
      style = props.style,
      onFileChange = props.onFileChange,
      _props$accept = props.accept,
      accept = _props$accept === void 0 ? '*' : _props$accept,
      _props$isPaste = props.isPaste,
      isPaste = _props$isPaste === void 0 ? false : _props$isPaste,
      _props$isMultiple = props.isMultiple,
      isMultiple = _props$isMultiple === void 0 ? false : _props$isMultiple,
      _props$isDrop = props.isDrop,
      isDrop = _props$isDrop === void 0 ? false : _props$isDrop;
  var inputRef = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      inputKey = _useState2[0],
      setInputKey = _useState2[1];

  var onClick = useCallback(function () {
    var _a;

    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
  }, []);
  var uploadChange = useRefCallback(function (e) {
    var files = e.target.files;

    if (!files) {
      throw new Error('target.files is null, please check!');
    }

    onFileChange === null || onFileChange === void 0 ? void 0 : onFileChange(_toConsumableArray(files));
    setInputKey(inputKey + 1);
  });
  var handlePaste = useRefCallback(function (e) {
    if (!isPaste) {
      return;
    }

    var files = [];

    for (var _i2 = 0, _arr = _toConsumableArray(e.clipboardData.items); _i2 < _arr.length; _i2++) {
      var item = _arr[_i2];

      if (item.kind === 'file') {
        var file = item.getAsFile();

        if (!file) {
          continue;
        }

        isAccept(file, accept) && files.push(file);
      }
    }

    files.length && (onFileChange === null || onFileChange === void 0 ? void 0 : onFileChange(files));
  });
  return React.createElement(ViewDropTrigger, {
    isMultiple: isMultiple,
    accept: accept,
    onFileChange: onFileChange,
    disabled: !isDrop
  }, React.createElement("div", {
    className: className,
    style: _objectSpread(_objectSpread({}, DEFAULT_TRIGGER_STYLE), style),
    onClick: onClick,
    onPaste: handlePaste
  }, React.createElement("input", {
    type: "file",
    multiple: isMultiple,
    key: inputKey,
    style: {
      display: 'none'
    },
    accept: accept,
    ref: inputRef,
    onChange: uploadChange
  }), children || 'upload +'));
};